import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroModule } from './ng-zorro.module';
import { RouterModule } from '@angular/router';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { NoSpacesDirective } from './directives/no-space.directive';
import { AllowOnlyNumberDirective } from './directives/number-only.directive';
import { AccountDisableComponent } from './components/account-disable/account-disable.component';

@NgModule({
  declarations:[
    ContactUsComponent,
    AboutUsComponent,
    TermsAndConditionsComponent,
    PrivacyPolicyComponent,
    AllowOnlyNumberDirective,
    NoSpacesDirective,
    AccountDisableComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroModule,
    ScrollingModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroModule,
    ScrollingModule,
    AllowOnlyNumberDirective,
    NoSpacesDirective,
    AccountDisableComponent
  ],
  schemas : [NO_ERRORS_SCHEMA]
})
export class SharedModule { }
